import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import FlatCard from "../../../../../atoms/FlatCard";
import { PatientDto, RxDto } from "../../../../../api-client";
import { useCallback, useEffect, useMemo, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { handleParseInput } from "../../../../../helpers/parseInput";
import {
  useMasterTables,
  getTherapyId,
  resolveTarifGroupForRxType,
  useIcdCodes,
} from "../../../../../stores/MasterTables";
import useStore from "../../../../../helpers/useStore";
import EditTable, { validateFrequency, validateTherapy } from "../../../../../molecules/Editable";
import Controls from "../../../../../atoms/Controls";
import { Add, Delete } from "@mui/icons-material";
import { observer } from "mobx-react";
import { DoctorContext } from "../../../../../stores/Doctor/doctor.provider";
import DoctorDialog from "../../../../PatientDataEntryForm/Doctor";
import { LabelItem, ValueItem } from "../../../../../molecules/FlexList";
import notificationStore from "../../../../../stores/Notification/notificationStore";
import { confirmDoctorClinicJoin } from "../../../../DoctorManagement/confirmDoctorClinicJoin";
import { confirmDoctorClinicMismatch } from "../../../../DoctorManagement/confirmDoctorClinicMismatch";
import { RxStoreContext } from "../../../../../stores/Rx/rx.provider";
import { PatientsContext } from "../../../../../stores/Patients/patients.provider";
import ValidationCard, { formType } from "../../../../../molecules/ValidationCard";
import { UserContext } from "../../../../../stores/User/User.provider";
import { useUserAccounts } from "../../../../../stores/User/User.hooks";
import RxFormsData from "../RxFormsData";
import WarningDialog from "../../../../../atoms/WarningDialog";
import { rxuseForm } from "../../../../PatientDataEntryForm/Form";
import {
  ClinicForModal,
  Doctor,
} from "../../../../DoctorManagement/DoctorTabContent/doctor-client-types";
import VerordnungDialog from "../Kasse/VerordnungDialog";
import DoctorCard from "../../../../../molecules/DoctorCard";
import DoctorClinicAutocomplete from "../DoctorClinicAutocomplete";
import moment from "moment";
import { usePatient } from "../../../../../stores/Patients/patient.queries";
import { useRx } from "../../../../../stores/Rx/rx.queries";
import { EntryType } from "../../../../PatientDataEntryForm/Receipt";
import { useSaveRxs } from "../../../../../stores/Rx/rx.mutations";
import SimpleDocumentViewer from "../../../../Documents/SimpleDocumentViewer";
import { formTherapyFromLine } from "../../../../../helpers/therapyRxLabel";
import { rowNamesTerm, rowTermText } from "../../../../../helpers/rxFormRow";
import type { RowData } from "../../../../../molecules/Editable";
import { usePrescribedTherapyOptions } from "../../../../../stores/MasterTables/masterTables.queries";

interface PrivateProps {
  selectedRxId?: string;
  patientId?: number;
  handleNewFormData?: (data: RxDto) => void;
  newFormData?: any;
  values?: any; //required only entryType is newRx
  openRx: boolean;
  onCloseRx: any;
  entryType?: EntryType;
  // therapyTableData:any;
}

const Private: React.FC<PrivateProps> = observer(
  ({
    selectedRxId,
    patientId,
    handleNewFormData,
    newFormData,
    values,
    openRx,
    onCloseRx,
    entryType,
  }) => {
    const [trackFormChange, setTrackFormChange] = useState(false);
    const [selectedChipCard, setSelectedChipCard] = useState<string | null>(null);
    const [unsavedChanges, setUnsavedChanges] = useState(false);
    const [unsavedChangesWarning, setShowunsavedChangesWarning] = useState(false);
    const [savingRx, setSavingRx] = useState(false);
    const [selectedPayer, setSelectedPayer] = useState(null);
    const [selectedDoctor, setSelectedDoctor] = useState(null);
    const [fetchedData, setFetchedData] = useState(null);
    const PatientStore = useStore(PatientsContext);
    const DoctorStore = useStore(DoctorContext);
    const { getClinicById, getDoctorById, createDoctorWithClinic } = DoctorStore;
    const RxStore = useStore(RxStoreContext);
    const { saveRxs } = RxStore;
    const UserStore = useStore(UserContext);
    const { user } = UserStore;
    const accounts = useUserAccounts();
    const { data: masterTablesData } = useMasterTables();
    // Prescribed TERMS — the catalog level a prescription names (MD-232).
    const { data: termOptions = [] } = usePrescribedTherapyOptions();
     const [isDocumentViewerOpen, setIsDocumentViewerOpen] = useState(false);

    // Fetch RX data using the rxId from store
    const { data: rxData, isLoading: isRxLoading, error: rxError } = useRx(selectedRxId!);
    const rowData = entryType && newFormData ? newFormData : rxData;

    // Get patient data from store
    const { data: patientData } = usePatient(patientId!);
    const patientValues = entryType === EntryType.newRx && values ? values : patientData;
     const { mutate: patientSaveRxs } = useSaveRxs();
    // TODO: Replace getICD with appropriate hook-based solution
    const [formValues, setFormValues] = useState<any>(rowData); //For now any to be refactored
    const [currentICD, setCurrentICD] = useState(null)
    const { data: icdObject } = useIcdCodes(currentICD,false); // disabled initially
    // const [open, setOpen] = useState(true);
    const [filteredDiagnoseGroups, setFilteredDiagnoseGroups] = useState([]);
    // const [isDoctorNumberDisabled, setIsDoctorNumberDisabled] = useState(true);
    const [doesClinicExist, setDoesClinicExist] = useState(false);
    const [isClinicModalOpen, setIsClinicModalOpen] = useState(false);
    const [isClinicModalEditMode, setIsClinicModalEditMode] = useState(false);
    const [currentClinicId, setCurrentClinicId] = useState("");
    const [creationResponse, setCreationResponse] = useState<any>({
      id: "",
      clinics: [],
      contactInfo: {},
      doctorId: "",
      clinicId: "",
    });
    const [currentDoctorId, setCurrentDoctorId] = useState("");
    const [doesDoctorExist, setDoesDoctorExist] = useState(false);
    const [currentClinic, setCurrentClinic] = useState<ClinicForModal | undefined>(
      formValues?.clinic
    );
    const [showClinicData, setShowClinicData] = useState(false);
    const [currentDoctor, setCurrentDoctor] = useState<Doctor | ClinicForModal>();
    const [loading, setLoading] = useState(false);
    const [autocompleteSearchTerm, setAutocompleteSearchTerm] = useState("");

    const insurer = (masterTablesData || [])
      .filter((obj: any) => "insurer" in obj)
      .map((obj: any) => obj.insurer);
    const diagnoseGroups = (masterTablesData || [])
      .filter((obj: any) => "diagnosisGroups" in obj)
      .map((obj: any) => obj.diagnosisGroups);
    const rxType = (masterTablesData || [])
      .filter((obj: any) => "rxType" in obj) // Filter objects that have the insuranceStatus property
      .map((obj: any) => obj.rxType);

    const account = (masterTablesData || [])
      .filter((obj: any) => "account" in obj)
      .map((obj: any) => obj.account);

    // Derive therapyType from the selected account (Physio vs. Ergo)
    const accountTherapyType = useMemo(() => {
      if (!formValues?.accountId || !accounts) return "Physiotherapie";
      const selectedAccount = accounts.find(
        (a: any) => a.name === formValues.accountId || a.id === formValues.accountId
      );
      return selectedAccount?.therapyType || "Physiotherapie";
    }, [formValues?.accountId, accounts]);

    /**
     * Filters diagnose groups by the selected Rx type and current account therapy type.
     *
     * Why this exists:
     * - Rx type controls which diagnose groups are allowed.
     * - Account (Physio/Ergo) further narrows the valid diagnose groups.
     */
    const filterDiagnoseGroups = (rxtype: any) => {
      const filtered = diagnoseGroups[0].filter(
        (option: any) =>
          option.RxType?.id === rxtype &&
          (!option.therapyType || option.therapyType === accountTherapyType)
      );
      setFilteredDiagnoseGroups(filtered);
    };
    const [icdCodeEntries, setIcdCodeEntries] = useState(formValues?.icdCodeEntries);
    const [isAddEditDialogOpen, setAddEditDialogOpen] = useState(false);
    const [therapyTableData, setTherapyTableData] = useState([]);
    const [tarifGroupOptions, setTarifGroupOptions] = useState<string[]>([]);

    const handleOpenAddEditDialog = (lanr: string | null, bsnr: string | null) => {
      setAddEditDialogOpen(true);
    };

    const handleUnsavedChangesWarning = () => {
      handleSave();
    };
    const handleCloseRxDialog = () => {
      // console.log("shjsakjsajj", unsavedChanges);
      if (unsavedChanges) {
        // If there are unsaved changes, set a state to open the warning dialog
        setShowunsavedChangesWarning(true);
      } else {
        onCloseRx();
      }
    };
    const handleCloseUnsavedChangesWarning = () => {
      onCloseRx();
      // If user cancels and chooses not to continue, close the warning dialog
      setShowunsavedChangesWarning(false);
    };

    const handleOpenDocumentViewer = () => {
      setIsDocumentViewerOpen(true);
    };

    const handleCloseDocumentViewer = () => {
      setIsDocumentViewerOpen(false);
    };

    useEffect(() => {
      const fetchData = async () => {
        // console.log("akjsakjsksak", formValues);

        // Phase 1: initialize Rx type + tarif group from existing Rx, not hardcoded Privat.
        const initialRxTypeId =
          rowData?.rxtype?.id || rowData?.rxtype || "Privat/Selbstzahler";
        const resolvedForInitialRxType = resolveTarifGroupForRxType(
          masterTablesData || [],
          initialRxTypeId,
          rowData?.tarifGroupId || rowData?.tarifGroup?.id,
          accountTherapyType
        );
        setTarifGroupOptions(resolvedForInitialRxType.options);

        const initialTarifGroupId =
          rowData?.tarifGroupId ||
          rowData?.tarifGroup?.id ||
          resolvedForInitialRxType.nextTarifGroupId;

        const rxs = rowData?.therapyRxs?.map((therapy: any) => ({
          id: therapy.id || uuidv4(),
          // Carried through the round trip: this is what names the term on
          // save. An API line has `rawText`; fall back to the term id so a
          // line stored before rawText existed still resolves.
          rawText: therapy.rawText ?? therapy.prescribedTherapyId ?? null,
          // MD-232: a line names the prescribed TERM. It no longer carries a
          // therapy, and the form must not synthesise a line-item id from
          // `${tarifGroup}_${abbreviation}` — which line item a term becomes is
          // resolved server-side per slot from the tarif group and credentials.
          therapy: formTherapyFromLine(therapy),
          amount: therapy.amount,
          frequency: therapy.frequency || { id: "", text: "" },
          unitsPerDay: therapy.unitsPerDay,
          isDoubled: (therapy.unitsPerDay ?? (therapy.isDoubled ? 2 : 1)) > 1,
          rxSeries: therapy.rxSeries,
        }));

        const updatedformValues = {
          ...rowData,
          firstName: patientValues?.firstName || "",
          lastName: patientValues?.lastName || "",
          dob: moment(patientValues?.dob).format("YYYY-MM-DD") || "",

          insuranceNo: patientValues?.insuranceNo || "",
          // Receiptpayer: formValues.payer.insurer || "",
          Receiptpayer:
            insurer[0]?.find((option: any) => option.id === rowData?.Receiptpayer)?.name ||
            rowData?.payer?.name,
          chipcard: rowData?.chipcard || rowData?.payer?.ik,
          // doctorId: formValues.doctorId,
          diagnosegroup:
            diagnoseGroups[0]?.find((option: any) => option.id === rowData?.diagnosegroup)
              ?.code || rowData?.diagnosisGroup?.code,
          tarifGroupId: initialTarifGroupId,
          rxtype: initialRxTypeId,
          isHomeVisit: rowData?.isHomeVisit,
          accountId:
            account[0]?.find((option: any) => option.id === rowData?.accountId)?.name ||
            rowData?.account?.name,
          // status: formValues.status || "",
          signatureStatus: rowData?.signatureStatus || "",
          insuranceStatus: rowData?.insuranceStatus || patientValues?.status,
          therapyRxs: rxs,
          // rxtype:formValues.rxtype?.id || "",
          // accountId:formValues.account?.id || "",
          // chipcard: formValues.payer?.id || "",
          // doctorId: formValues.doctor?.contactInfo?.lastName || "",
          bsnr: rowData?.clinicId || rowData?.practiceNumber || "",
          // diagnosegroup: formValues.diagnosisGroup?.code || "",
          icdCodeEntries: icdCodeEntries,
          // Map new API field names to form's internal keys
          doctorNumber: rowData?.LANR || "",
          practiceNumber: rowData?.BSNR || "",
          doctorId: rowData?.doctorId || rowData?.doctorNumber || "",
          clinicId: rowData?.clinicId || rowData?.practiceNumber || "",
        };

        setFormValues(updatedformValues);
        const therapyTableData = updatedformValues.therapyRxs
          ? updatedformValues.therapyRxs.map((therapy: any) => ({
              id: therapy.id,
              date: formValues.date, // Use formValues.date if needed
              rawText: therapy.rawText ?? therapy.prescribedTherapyId ?? null,
              therapy: therapy.therapy?.abbreviation ?? "",
              amount: therapy.amount,
              frequency: therapy.frequency?.text,
              unitsPerDay: therapy.unitsPerDay,
              isDoubled: (therapy.unitsPerDay ?? (therapy.isDoubled ? 2 : 1)) > 1,
              rxSeries: therapy.rxSeries,
            }))
          : [];
        setTherapyTableData(therapyTableData);
      };
      fetchData();

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [patientValues?.rxs, rowData]);

    useEffect(() => {
      setCurrentDoctor(formValues?.doctor);
      setCurrentClinic(formValues?.clinic);
    }, [formValues?.doctor, formValues?.clinic]);

    // Keep display fields and FK IDs in sync with the actual doctor/clinic
    useEffect(() => {
      if (currentDoctor) {
        const lanr = (currentDoctor as any).LANR || "";
        setFormValues((prev: any) => ({ ...prev, doctorNumber: lanr, doctorId: (currentDoctor as any).id || prev.doctorId }));
      }
    }, [currentDoctor]);

    useEffect(() => {
      if (currentClinic) {
        const bsnr = (currentClinic as any).BSNR || "";
        setFormValues((prev: any) => ({ ...prev, practiceNumber: bsnr, clinicId: currentClinic.id || prev.clinicId }));
      }
    }, [currentClinic]);

    useEffect(() => {
      if (creationResponse && creationResponse.doctorId && creationResponse.clinicId) {
        setCurrentDoctor({
          id: creationResponse.doctorId,
          LANR: creationResponse.LANR,
          contactInfo: creationResponse.contactInfo as any,
          clinics: creationResponse.clinics,
        });
        const matchedClinic = (creationResponse.clinics || []).find((clinic: any) => clinic.id === creationResponse.clinicId);
        setCurrentClinic(matchedClinic as any || undefined);
        setFormValues((prev: any) => ({
          ...prev,
          doctorId: creationResponse.doctorId || "",
          clinicId: creationResponse.clinicId || "",
          doctorNumber: creationResponse.LANR || "",
          practiceNumber: matchedClinic?.BSNR || "",
        }));
      }
    }, [creationResponse]);

    // console.log("TAzz<szszusu", therapyTableData);

    /**
     * Persists the current Private Rx form values.
     *
     * Important behavior:
     * - Resolves Rx type defensively (supports string and object shape).
     * - Requires a valid tarif group for the selected Rx type.
     * - Builds therapy IDs with the selected tarif group prefix.
     */
    const handleSave = async (event?: any) => {
      if (event) {
        setSavingRx(false);
        event.preventDefault(); // Prevent default form submission behavior
      }
      try {
        if (rxvalidate()) {
          // The doctor must actually be registered at the practice the Rx names:
          // the stamp takes its telephone number from the PRACTICE, so a
          // mismatched pair prints a stranger's number on a document that leaves
          // the building. Asked here rather than on a field, because the Arzt-Nr
          // check only fires when that field loses focus - correcting the BSNR
          // afterwards, or re-saving an Rx loaded from the database, slips past it.
          if (!(await confirmDoctorClinicMismatch(currentDoctor, currentClinic))) {
            return;
          }
          // console.log("atzsashjsajjsadsm", formValues.therapyRxs, formValues);
          setSavingRx(true);

          // Phase 2: use selected Rx type + tarif group dynamically in the payload.
          /**
           * Rx type can come from different data shapes depending on origin
           * (existing row data vs. select change event). Normalize to ID string.
           */
          const selectedRxTypeId =
            typeof formValues?.rxtype === "object"
              ? formValues?.rxtype?.id
              : formValues?.rxtype;
          const selectedTarifGroupId =
            formValues?.tarifGroupId ||
            (tarifGroupOptions.length === 1 ? tarifGroupOptions[0] : "");

          if (!selectedRxTypeId) {
            throw new Error("Bitte wählen Sie einen Rezept-Typ.");
          }

          if (!selectedTarifGroupId) {
            throw new Error(
              "Bitte wählen Sie eine Tarifgruppe für den gewählten Rezept-Typ."
            );
          }

          const therapyRxs: any[] = [];
          // MD-232: a row is real when it NAMES A TERM, not when it carries a
          // resolved line-item id (see rowNamesTerm).
          const formTherapies = (formValues.therapyRxs || []).filter(rowNamesTerm);

          // Loop through tableData to collect therapy data
          for (const therapy of formTherapies) {
            // const tarifTherapy = getTherapyId("Privat", therapy.therapy);
            // if (!tarifTherapy) {
            //   notificationStore.showMessage(`Heilmittel ${therapy.therapy} nicht gefunden`, "error");
            //   continue;
            // }

            const therapyObj = {
              id: therapy.id || uuidv4(),
              amount: therapy.amount || "",
              // MD-232: the line names the prescribed TERM as typed; the server
              // resolves it text -> alias -> term. The synthesized
              // `${tarifGroup}_${abbreviation}` therapy id below is the
              // pre-refactor client-side line-item guess — kept only because
              // the required-field check and the table cell still read it.
              rawText: therapy.rawText ?? therapy?.therapy?.abbreviation ?? null,
              therapy: {
                id: `${selectedTarifGroupId}_${therapy?.therapy?.abbreviation}`,
                abbreviation: therapy?.therapy?.abbreviation,
              },
              frequency: therapy.frequency.id ? therapy.frequency : { id: "1-3", text: "1-3" },
              isHomeVisit: therapy.isHomeVisit,
              unitsPerDay: therapy.unitsPerDay,
              isDoubled: (therapy.unitsPerDay ?? (therapy.isDoubled ? 2 : 1)) > 1,
              rxSeries: therapy.rxSeries,
            };

            // Check if therapy data exists before adding
            // `therapy.id` is synthesized above as `${tarif}_${abbreviation}`,
            // so it is truthy even for a row with no Heilmittel at all
            // ("Privat_undefined") — it cannot answer "does this row name a
            // term". rowNamesTerm can.
            if (
              !(therapyObj.frequency && therapyObj.frequency.id) ||
              !rowNamesTerm(therapyObj) ||
              !therapyObj.amount
            ) {
              throw new Error(
                "Bitte fügen Sie die Behandlung hinzu, um das Rezept zu speichern/bearbeiten (Therapie, Menge, Häufigkeit sind Pflichtfelder) und deaktivieren Sie auch die Zelle nach der Bearbeitung!"
              );
            }
            const validTherapy = validateTherapy(
              rowTermText(therapyObj),
              masterTablesData || [],
              termOptions
            );
            const validFrequency = validateFrequency(
              therapyObj.frequency.id,
              masterTablesData || []
            );
            if (!validTherapy || !validFrequency) {
              throw new Error("Bitte geben Sie eine gültige Therapie und Häufigkeit ein.");
            }

            therapyRxs.push(therapyObj);
          }
          // console.log("tzzssjjsjxjs", therapyRxs);

          const updatedRxValues: any = {
            ...formValues,
              id: formValues?.id || "",
            rxNumber:
              formValues.rxNumber || "",
            doctorId: formValues.doctorId,
            clinicId: formValues.clinicId,
            LANR: formValues.doctorNumber || "",
            BSNR: formValues.practiceNumber || "",
            accountId:
              account[0].find((option: any) => option.name === formValues.accountId)?.id ||
              formValues.accountId,
            rxtype: selectedRxTypeId,
            diagnosegroup:
              diagnoseGroups[0].find((option: any) => option.code === formValues.diagnosegroup)
                ?.id || formValues.diagnosegroup,
            Receiptpayer:
              insurer[0].find((option: any) => option.name === formValues.Receiptpayer)?.id ||
              formValues.Receiptpayer,
            therapyRxs: therapyRxs.filter(rowNamesTerm),
            tarifGroupId: selectedTarifGroupId,
          };

          // Derive doctor/clinic IDs from the entity state (single source of truth)
          if (currentDoctor) {
            updatedRxValues.doctorId = (currentDoctor as any).id || formValues.doctorId;
            updatedRxValues.LANR = (currentDoctor as any).LANR || formValues.doctorNumber || "";
          } else {
            updatedRxValues.doctor = null;
            updatedRxValues.doctorId = null;
            updatedRxValues.doctorNumber = "";
            updatedRxValues.LANR = "";
          }
          if (currentClinic) {
            updatedRxValues.clinicId = currentClinic.id || formValues.clinicId;
            updatedRxValues.BSNR = (currentClinic as any).BSNR || formValues.practiceNumber || "";
          } else {
            updatedRxValues.clinic = null;
            updatedRxValues.clinicId = null;
            updatedRxValues.practiceNumber = "";
            updatedRxValues.BSNR = "";
          }

          // // Handle form submission logic here
          // const updatedFormData = {

          //   patient:{
          //     ...patientValues,
          //   firstName: formData.patient?.firstName || "",
          //   lastName: formData.patient?.lastName || "",
          //   dob: formData.patient?.dob || ""},
          //   rxs: updatedRxValues
          // };
          const updatedFormData = {
            ...patientValues,
            rxs: entryType
              ? [updatedRxValues] // If newRx is truthy, replace all rxs with updatedRxValues
              : patientValues?.rxs?.map((rx: any) =>
                  rx.id === formValues.id ? updatedRxValues : rx
                ),
          };
          setUnsavedChanges(false);
          setFormValues(updatedRxValues);
          if (entryType === EntryType.newRx) {
            // updateFormData(updatedRxValues);
            handleNewFormData && handleNewFormData(updatedRxValues);
            //This for newRx setting rx form
            // mainFormSubmit()
          } else {
            patientSaveRxs({ patientId: patientId!, rxs: [updatedRxValues] });
            onCloseRx();
            // handleData(updatedFormData);
            // await searchPatient({ id: patientValues.id });
          }
          
        } else {
          notificationStore.showMessage(
            "Bitte füllen Sie alle erforderlichen Felder aus",
            "warning"
          );
        }
      } catch (error: any) {
        console.error("Error saving Rx:", error);
        notificationStore.showMessage(
          error.message || "Fehler beim Speichern des Rezepts",
          "error",
          error
        );
      } finally {
        // Set loading back to false when the API call is complete
        setSavingRx(false);
      
      }
    };

    //   const handleOpen = () => {
    //     setOpen(true);
    //   };

    // const handleClose = () => {
    //   setOpen(false);
    // };
    const handletherapyTableDataChange = (data: RowData[]) => {
      // console.log("datatttzz", data);
      // // Create a new array to hold the updated data
      const updatedData: any[] = [];
      data.forEach((item: any) => {
        // Divide the amount by 2 for the original item
        const updatedAmount = item.amount;

        // Update the original item with the new amount
        const updatedItem = {
          ...item,
          therapy: { id: item.therapy, abbreviation: item.therapy },
          frequency: { id: item.frequency, text: item.frequency },
          amount: updatedAmount,
          unitsPerDay: item.unitsPerDay,
          isDoubled: (item.unitsPerDay ?? (item.isDoubled ? 2 : 1)) > 1,
        };

        // Doubling is `unitsPerDay` on the one line (MD-232) — no split row.
        updatedData.push(updatedItem);
      });
      // setFormValues((prevData: any) => ({
      //   ...prevData,
      //   therapyRxs: updatedData,
      // }));
      // Update the form values state and call setUnsaved(true) if the data has changed
      setFormValues((prevData: any) => {
        const newFormValues = {
          ...prevData,
          therapyRxs: updatedData,
        };
        const hasUnsavedChanges = prevData.therapyRxs?.some((prevItem: any, index: number) => {
          const updatedItem = updatedData[index];
          return (
            prevItem.abbreviation !== updatedItem.abbreviation ||
            prevItem.amount !== updatedItem.amount ||
            prevItem.frequency?.id !== updatedItem.frequency?.id ||
            prevItem.isDoubled !== updatedItem.isDoubled ||
            prevItem.rxSeries !== updatedItem.rxSeries
          );
        });

        // Usage
        if (prevData.therapyRxs && updatedData && hasUnsavedChanges) {
          setUnsavedChanges(true);
        }

        return newFormValues;
      });
      // console.log("jkkkkk", formValues);
    };
    const [isHausbesuchSelected, setHausbesuchSelected] = useState<boolean | null>(
      formValues.isHomeVisit
    );
    // console.log("auusuusiisi", formValues.isHomeVisit);
    const handleCheckboxChange = (event: any) => {
      const selectedValue = event.target.value; // "yes" or "no"

      if (selectedValue === "yes") {
        setHausbesuchSelected(true);
        // Set isHomeVisit to true if "yes" is selected
        handleInputChange({
          target: {
            name: "isHomeVisit",
            value: true,
          } as unknown as EventTarget & HTMLInputElement, // Cast to EventTarget & HTMLInputElement
        } as React.ChangeEvent<HTMLInputElement>);
      } else if (selectedValue === "no") {
        setHausbesuchSelected(false);
        // Set isHomeVisit to false if "no" is selected
        handleInputChange({
          target: {
            name: "isHomeVisit",
            value: false,
          } as unknown as EventTarget & HTMLInputElement, // Cast to EventTarget & HTMLInputElement
        } as React.ChangeEvent<HTMLInputElement>);
      } else {
        setHausbesuchSelected(null); // Set null if neither is selected
        // Set isHomeVisit to null if neither checkbox is selected
        handleInputChange({
          target: {
            name: "isHomeVisit",
            value: null,
          } as unknown as EventTarget & HTMLInputElement, // Cast to EventTarget & HTMLInputElement
        } as React.ChangeEvent<HTMLInputElement>);
      }
    };

    /**
     * Central form input handler.
     *
     * Notes for reviewers:
     * - Handles generic field updates.
     * - Applies Rx type -> tarif group dependency logic.
     * - Keeps diagnose group consistent when Rx type changes.
     */
    const handleInputChange = (
      event: React.ChangeEvent<HTMLInputElement>,
      index?: any,
      icdEntryId?: string
    ) => {
      // console.log("LUUZZ", event);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { name, value, checked, type, id } = event.target;
      setUnsavedChanges(true);

      const inputValue = type === "checkbox" ? checked : value;

      if (name === "practiceNumber") {
        // No character limit for Privat Rxs — allow UUIDs and non-standard IDs
      }

      if (name === "doctorNumber") {
        // No character limit for Privat Rxs — allow UUIDs and non-standard IDs
        // Only update the field, do not clear doctor info here!
        setFormValues((prevValues: any) => ({
          ...prevValues,
          doctorNumber: value,
        }));
        return;
      }
      // setFormChanged(true);
      // console.log("input", inputValue, checked);
      // console.log("Event:", event.target.name, event.target.value, index);
      if (name === "date" && formValues.isPerpetual && value) {
        setFormValues((prevValues: any) => ({
          ...prevValues,
          unvirtualize: true,
        }));
      }

      // Check if the input is for icdCodeEntries
      if (name.startsWith("icdCodeEntries")) {
        const inputElement = document.querySelector(`[name="${name}"]`) as
          | HTMLInputElement
          | HTMLTextAreaElement;
        const cursorPosition = inputElement?.selectionStart || 0;
        let updatedValue = value;
        let newCursorPosition = cursorPosition; // Initialize new cursor position

        // Check if the length is at least 4 and if a period needs to be inserted
        if (value.length >= 4) {
          // Check if the period already exists at the correct position
          if (!value.includes(".")) {
            // Insert a period after the third character if it's not already there
            updatedValue = value.slice(0, 3) + "." + value.slice(3);

            // Adjust cursor position if a period was inserted before the original cursor position
            if (cursorPosition > 3) {
              newCursorPosition = cursorPosition + 1; // Move cursor one position forward
            }
          }
        }

        // Update the form values with the correctly formatted value
        setFormValues((prevValues: any) => ({
          ...prevValues,
          icdCodeEntries: prevValues.icdCodeEntries.map((icdEntry: any, i: number) => {
            return i === index
              ? { id: icdEntryId || undefined, userText: updatedValue }
              : { id: icdEntry?.id, userText: icdEntry?.userText || "" };
          }),
        }));

        // Restore cursor position after the update
        setTimeout(() => {
          if (inputElement) {
            inputElement.selectionStart = inputElement.selectionEnd = newCursorPosition;
          }
        }, 0);
      }

      // if (name.startsWith("icdCodeEntries")) {
      //   setFormValues((prevValues: any) => ({
      //     ...prevValues,
      //     icdCodeEntries: prevValues.icdCodeEntries.map((icdEntry: any, i: number) => {
      //       return i === index ? { id:icdEntryId || undefined, userText: inputValue } : {id:icdEntry?.id,userText:icdEntry?.userText|| ""};
      //     }),
      //   }));
      // }
      // Leitsymptomatik: the a/b/c/d codes and the patientenindividuelle flag are
      // independent — a Verordnung can require both, so neither clears the other.
      // Update form fields based on their names
      setFormValues((prevValues: any) => ({
        ...prevValues,
        [name]: id ? id : inputValue,
      }));

      // setFormValues((prevValues: any) => ({
      //   ...prevValues,
      //   rxs: prevValues.rxs.map((rx: any) => ({
      //     ...rx,
      //     [name]: id ? id : inputValue,
      //   })),
      // }));

      // if (name === 'rxtype') {
      //   filterDiagnoseGroups(value);
      // }

      if (name === "rxtype") {
        // The Rezept-typ DECIDES the tarif group; `resolveTarifGroupForRxType`
        // is the shared rule so this form cannot drift from the E13 form or
        // the quick-add dialog.
        const selectedRxTypeId = String(id ? id : inputValue);
        const { options, nextTarifGroupId, requiresChoice } = resolveTarifGroupForRxType(
          masterTablesData || [],
          selectedRxTypeId,
          formValues?.tarifGroupId,
          accountTherapyType
        );
        setTarifGroupOptions(options);

        setFormValues((prevValues: any) => ({
          ...prevValues,
          diagnosegroup: null, // Clear diagnosegroup when rxtype changes
          tarifGroupId: nextTarifGroupId,
        }));

        if (requiresChoice) {
          notificationStore.showMessage(
            "Bitte wählen Sie eine Tarifgruppe für den gewählten Rezept-Typ.",
            "warning"
          );
        }

        filterDiagnoseGroups(selectedRxTypeId);
      }
      // if (name === "practiceNumber") {
      //   // Autopopulate doctor and bsnr based on LANR selection
      //   const selectedDoctor: any = doctorOptions.find(
      //     (doctor: any) => doctor.clinicNumber === Number(value)
      //   );
      //   setFetchedData(selectedDoctor);
      //   if (selectedDoctor) {
      //     setFormValues((prevFormValues: any) => ({
      //       ...prevFormValues,
      //       doctorId: selectedDoctor.id,
      //       doctorNumber: selectedDoctor.number,
      //     }));
      //     setSelectedDoctor(selectedDoctor.contactInfo.lastName);
      //     setSelectedLANR(selectedDoctor.number);
      //   }
      // }
      if (name === "Receiptpayer") {
        // Autopopulate doctor and bsnr based on LANR selection
        const selectedPayer: any = insurer[0].find(
          (option: any) => option.id === id || option.ik === value
        );
        // console.log("UZZHHHH", selectedPayer);
        if (selectedPayer) {
          setFormValues((prevFormValues: any) => ({
            ...prevFormValues,
            chipcard: selectedPayer?.ik,
            // tarifGroupId: selectedPayer?.tarifGroup.id,
          }));
          setSelectedChipCard(selectedPayer.ik);
          // console.log("selectedPayer", selectedPayer.name);
        }
      }

      if (name === "chipcard") {
        const selectedPayer: any = insurer[0].find((option: any) => option.ik === value);
        // console.log("UZZHHHH", selectedPayer);
        if (selectedPayer) {
          setFormValues((prevFormValues: any) => ({
            ...prevFormValues,
            Receiptpayer: selectedPayer.id,
            // tarifGroupId: selectedPayer?.tarifGroup?.id,
          }));

          setSelectedPayer(selectedPayer.name);
          // console.log("selectedPayer", selectedPayer.name);
        }
      }
      // console.log("GTII", formValues);

      // else if (name === "doctor") {
      //   // Autopopulate doctor and bsnr based on LANR selection
      //   const selectedDoctor: any = doctorOptions.find(
      //     (doctor: any) => doctor.contactInfo.firstNames===value

      //   );
      //   if (selectedDoctor) {
      //     setFormValues((prevFormValues: any) => ({
      //       ...prevFormValues,
      //       lanr: selectedDoctor.number,
      //       bsnr: selectedDoctor.clinicNumber,
      //     }));
      //     setSelectedLANR(selectedDoctor.number);
      //   }
      //   console.log('DOCTOR',selectedDoctor,formValues,value,doctorOptions)
      // }
    };
    const handleAddInput = () => {
      setIcdCodeEntries([...icdCodeEntries, { userText: "" }]);

      // Update the formValues state as well to reflect the new entry
      setFormValues((prevValues: any) => ({
        ...prevValues,
        icdCodeEntries: [...prevValues.icdCodeEntries, { userText: "" }],
      }));
    };
    const rxvalidate = (fieldValues = formValues) => {
      let temp: any = { ...rxerrors };
      if ("accountId" in fieldValues) temp.accountId = fieldValues.accountId ? "" : "Pflichtfeld";
      if ("rxtype" in fieldValues) temp.rxtype = fieldValues.rxtype ? "" : "Pflichtfeld";
      if ("tarifGroupId" in fieldValues)
        temp.tarifGroupId = fieldValues.tarifGroupId ? "" : "Pflichtfeld";

      rxsetErrors({
        ...temp,
      });

      if (fieldValues == formValues) return Object.values(temp).every((x) => x == "");
    };
    const { rxerrors, rxsetErrors } = rxuseForm(formValues, true, rxvalidate);
    //Could not find better way to implement this icdCode
        const handleICDCodeEntrySubmit = useCallback(
          async (icdEntry: any, index: number) => {
    
            try {
              setFormValues((prevValues: any) => {
                const updatedICDCodeEntries = prevValues.icdCodeEntries.map((entry: any, i: number) =>
                  i === index ? { id: icdEntry.id || "", userText: icdEntry.userText } : entry
                );
    
                // Avoid duplicating diagnosis text
                const existingICDTexts = prevValues.icdCodeEntries.map((e: any) => e.userText);
                const newDiagnosisText = existingICDTexts.includes(icdObject.text)
                  ? prevValues.diagnosisText
                  : prevValues.diagnosisText
                  ? `${prevValues.diagnosisText} ${icdObject.text}`
                  : icdObject.text;
    
                return {
                  ...prevValues,
                  icdCodeEntries: updatedICDCodeEntries,
                  diagnosisText: newDiagnosisText.trim(),
                };
              });
            } catch (error) {
              console.error("Error updating ICD entry:", error);
            }
          },
          [icdObject]
        );
    
        useEffect(() => {
          if (icdObject) {
            // Use latest index and currentICD
            const index = icdCodeEntries.findIndex((e:any) => e.userText === currentICD);
            handleICDCodeEntrySubmit(icdCodeEntries[index], index);
          }
        }, [icdObject]);
    // const handleICDCodeEntrySubmit = async (icdCode: any, index: number) => {
    //   try {
    //     // TODO: Replace with useIcdCodes hook or appropriate solution
    //     // const icdObject: any = await getICD(icdCode.userText);
    //     const icdObject: any = null; // Temporary placeholder
    //     console.log("OOPP", icdObject);
    //     if (icdObject) {
    //       // If the API call is successful and returns an icdObject, update the icdCodeEntries state with the normCode
    //       setFormValues((prevValues: any) => {
    //         const updatedICDCodeEntries = prevValues.icdCodeEntries.map(
    //           (icdEntry: any, i: number) => {
    //             return i === index
    //               ? { id: icdCode?.id || "", userText: icdCode.userText }
    //               : icdEntry;
    //           }
    //         );

    //         const concatenatedDiagnosisText = prevValues.diagnosisText
    //           ? `${prevValues.diagnosisText} ${icdObject.text}` // Append the new icdObject.text to the existing diagnosisText
    //           : icdObject.text;
    //         return {
    //           ...prevValues,
    //           icdCodeEntries: updatedICDCodeEntries,
    //           diagnosisText: concatenatedDiagnosisText.trim(), // Set diagnosisText to the concatenated value
    //         };
    //       });
    //     }
    //   } catch (error) {
    //     console.error("Error fetching ICD object:", error);
    //   }
    // };
    const handleDeleteTherapy = (therapyId: string) => {
      // Filter out the therapy that matches the given ID
      const updatedTherapies = formValues.therapyRxs.filter(
        (therapy: any) => therapy.id !== therapyId
      );
      const updatedTableData = updatedTherapies?.map((therapy: any) => ({
        id: therapy.id,
        date: formValues.date, // Use formValues.date if needed
        rawText: therapy.rawText ?? therapy.prescribedTherapyId ?? null,
        therapy: therapy.therapy.abbreviation,
        amount: therapy.amount,
        frequency: therapy.frequency?.text,
        unitsPerDay: therapy.unitsPerDay,
        isDoubled: (therapy.unitsPerDay ?? (therapy.isDoubled ? 2 : 1)) > 1,
        rxSeries: therapy.rxSeries,
      }));
      setTherapyTableData(updatedTableData);

      // Update formData state with new therapy list
      setFormValues({
        ...formValues,
        therapyRxs: updatedTherapies,
      });
    };

    const handlePracticeNumberInteraction = async (
      e: React.FocusEvent<HTMLInputElement> | React.KeyboardEvent<HTMLInputElement>
    ) => {
      const value = (e.target as HTMLInputElement).value;

      const isKeyboardEvent = e.type === "keydown";
      const isTriggerKey =
        (e as React.KeyboardEvent).key === "Enter" || (e as React.KeyboardEvent).key === "Tab";

      // For Privat Rxs: allow any non-empty value to trigger lookup (no 9-digit restriction)
      if ((e.type === "blur" || isTriggerKey) && value.length >= 0) {
        try {
          if (value.length > 0) {
            const clinicData = (await getClinicById(value)) as ClinicForModal;
            if (clinicData) {
              setDoesClinicExist(true);
              setCurrentClinic(clinicData);
              setFormValues((prev: any) => ({ ...prev, clinicId: clinicData.id }));
              setShowClinicData(true);
            } else {
              // const inputValue = selectedBSNR || formValues?.practiceNumber;
              setDoesClinicExist(false);
              setCurrentClinicId(value);
              setCurrentDoctorId(currentDoctor?.id || "");
              setShowClinicData(false);
              setCurrentClinic(undefined);
              setIsClinicModalOpen(true);
            }
          } else if (value.length === 0) {
            setCurrentClinic(undefined);
          }
        } catch (error) {
          console.error("Error fetching clinic:", error);
        }
      }
    };

    const handleGetDoctorById = async (
      e: React.FocusEvent<HTMLInputElement> | React.KeyboardEvent<HTMLInputElement>
    ) => {
      const value = (e.target as HTMLInputElement).value;

      const isKeyboardEvent = e.type === "keydown";
      const isTriggerKey =
        (e as React.KeyboardEvent).key === "Enter" || (e as React.KeyboardEvent).key === "Tab";

      // For Privat Rxs: allow any non-empty value to trigger lookup (no 9-digit restriction)
      if ((e.type === "blur" || isTriggerKey) && value.length >= 0) {
        try {
          if (value.length > 0) {
            const doctorData: any = await getDoctorById(value);
            if (doctorData) {
              setDoesDoctorExist(true);
              setCurrentDoctor(doctorData);
              setFormValues((prev: any) => ({ ...prev, doctorId: doctorData.id }));
              // Only check association if currentClinic is set and valid
              if (currentClinic && currentClinic.id) {
                const isDoctorInClinic = doctorData.clinics?.some(
                  (clinic: any) => clinic.id === currentClinic.id
                );
                if (isDoctorInClinic) {
                  notificationStore.showMessage(
                    "This doctor exists and is already associated with this clinic",
                    "success"
                  );
                } else {
                  const confirmed = await confirmDoctorClinicJoin(doctorData, currentClinic);
                  if (!confirmed) {
                    // User cancelled — clear the doctor selection (treat as a mistake).
                    setCurrentDoctor(undefined);
                    setDoesDoctorExist(false);
                    setFormValues((prev: any) => ({ ...prev, doctorId: "", doctorNumber: "" }));
                    return;
                  }
                  notificationStore.showMessage(
                    "This doctor exists already and will now get associated with this clinic",
                    "success"
                  );
                  handleAssociateDoctorToClinic(doctorData);
                }
              } else {
                // No clinic entered yet, just set doctor, do not associate
                notificationStore.showMessage(
                  "Bitte geben Sie zuerst eine gültige Betriebsstätten-Nr. (BSNR) ein.",
                  "warning"
                );
              }
            } else {
              setDoesDoctorExist(false);
              setIsClinicModalOpen(true);
              setCurrentDoctorId(value);
              setCurrentClinicId(currentClinic?.id || "");
            }
          } else if (value.length === 0) {
            setCurrentDoctor(undefined);
          }
        } catch (error) {}
      }
    };

    enum ReportMethod {
      Email = "Email",
      Fax = "Fax",
      Post = "Post",
    }

    const handleAssociateDoctorToClinic = async (doctorData: any) => {
      const createDoctorClinicDto = {
        id: doctorData?.id || "",
        contactInfo: {
          salutation: doctorData?.contactInfo?.salutation || "",
          firstNames: doctorData?.contactInfo?.firstNames || "",
          lastName: doctorData?.contactInfo?.lastName || "",
        },
        clinics: [
          {
            id: currentClinic?.id || "",
            contactInfo: {
              businessName: currentClinic?.contactInfo?.businessName || "",
              phone1: currentClinic?.contactInfo?.phone1 || "",
              fax: currentClinic?.contactInfo?.fax || "",
              addressLine1: currentClinic?.contactInfo?.addressLine1 || "",
              addressLine2: currentClinic?.contactInfo?.addressLine2 || "",
              city: currentClinic?.contactInfo?.city || "",
              zip: currentClinic?.contactInfo?.zip || "",
              email: currentClinic?.contactInfo?.email || "",
            },
            notes: currentClinic?.notes || "",
            methodForDrReport: (currentClinic?.methodForDrReport as ReportMethod) || "Email",
            methodForRxOrder: (currentClinic?.methodForRxOrder as ReportMethod) || "Email",
          },
        ],
      };

      // Call createDoctorWithClinic to save data
      //  setLoading(true);
      try {
        const response = await createDoctorWithClinic(createDoctorClinicDto);
        return response;
      } catch (error) {
        console.error("Error saving doctor and clinic:", error);
      } finally {
        setLoading(false);
      }
    };

    const treatmentColumns: any[] = [
      // { field: "therapy", headerName: "Heilmittel", editable: true },
      {
        field: "Actions",
        headerName: "Aktionen",
        sortable: false,
        renderCell: (params: any) => (
          <IconButton size="small" onClick={() => handleDeleteTherapy(params.row.id)}>
            <Delete fontSize="small" />
          </IconButton>
        ),
      },
      { field: "amount", headerName: "Menge", editable: true },

      { field: "frequency", headerName: "Frequency", editable: true },
    ];

    // useEffect(() => {
    //     const inputValue = selectedBSNR || formValues?.practiceNumber;
    //     const isEmpty = !inputValue || inputValue.trim() === "";

    //     if (isEmpty === false) {
    //       setIsDoctorNumberDisabled(false);
    //     }
    // }, [selectedBSNR, formValues?.practiceNumber, currentClinic?.id]);

    const FormContent = (
      <Grid container spacing={2}>
        {/* Left Side */}
        <Grid item xs={12} md={6}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FlatCard title="">
                <Controls.Select
                  name="rxtype"
                  label="Rezept-typ"
                  value={formValues?.rxtype}
                  onChange={handleInputChange}
                  options={rxType[0]?.map((option: any) => ({
                    label: option?.text?.toString(),
                    value: option?.text?.toString(),
                    id: option?.id?.toString(),
                  }))}
                  required
                  error={rxerrors.rxtype}
                />
                <Controls.Select
                  name="tarifGroupId"
                  label="Tarif Group"
                  value={formValues?.tarifGroupId}
                  onChange={handleInputChange}
                  options={tarifGroupOptions.map((groupId) => ({
                    label: groupId,
                    value: groupId,
                    id: groupId,
                  }))}
                  required
                  error={rxerrors.tarifGroupId}
                />
                <Controls.Select
                  name="accountId"
                  label="Mandant"
                  id={1}
                  value={formValues?.accountId}
                  onChange={handleInputChange}
                  options={accounts?.map((option: any) => ({
                    label: option?.name?.toString(),
                    value: option?.name?.toString(),
                    id: option?.id?.toString(),
                  }))}
                  required
                  error={rxerrors.accountId}
                />
                <Controls.Input
                  name="name"
                  label="Name und Persönliche Daten"
                  value={`${patientValues?.salutation || ""} ${patientValues?.firstName} ${
                    patientValues?.lastName
                  }`}
                  disabled
                />
              </FlatCard>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Controls.DatePicker
                name="date"
                label="Rezeptdatum"
                value={formValues?.date}
                onChange={handleInputChange}
                formatDate="dd.MM.yy"
              />
              <Grid item xs={6}>
                <Controls.Checkbox
                  name="isPerpetual"
                  label="Dauerrezept"
                  value={formValues?.isPerpetual}
                  onChange={handleInputChange}
                />
              </Grid>
            </Grid>
            <Grid item xs={12}>
              {/* START */}
              <DoctorClinicAutocomplete
                onSelect={(doctor, clinic) => {
                  setCurrentDoctor(doctor as any);
                  setCurrentClinic(clinic as any);
                  setFormValues((prev: any) => ({
                    ...prev,
                    doctorId: doctor.id,
                    clinicId: clinic.id,
                    doctorNumber: doctor.LANR || "",
                    practiceNumber: clinic.BSNR || "",
                  }));
                  setDoesClinicExist(true);
                  setDoesDoctorExist(true);
                  setShowClinicData(true);
                  setUnsavedChanges(true);
                }}
                onAddNew={(searchTerm) => {
                  setAutocompleteSearchTerm(searchTerm);
                  setCurrentClinicId("");
                  setCurrentDoctorId("");
                  setIsClinicModalOpen(true);
                }}
              />

              <DoctorCard
                doctor={currentDoctor}
                clinic={currentClinic}
                formData={{
                  doctorNumber: formValues.doctorNumber,
                  clinic: currentClinic,
                }}
                showSignatureCheck={false}
                readOnlyView={false}
                onEdit={() => {
                  setCurrentClinicId(currentClinic?.id || "");
                  setCurrentDoctorId(currentDoctor?.id || "");
                  setIsClinicModalEditMode(true);
                  setIsClinicModalOpen(true);
                }}
                onRemoveDoctor={() => {
                  setCurrentDoctor(undefined as any);
                  setFormValues((prev: any) => ({
                    ...prev,
                    doctor: undefined,
                    doctorId: "",
                    doctorNumber: "",
                    LANR: "",
                  }));
                  setUnsavedChanges(true);
                }}
                onRemoveClinic={() => {
                  setCurrentClinic(undefined as any);
                  setFormValues((prev: any) => ({
                    ...prev,
                    clinic: undefined,
                    clinicId: "",
                    practiceNumber: "",
                    BSNR: "",
                  }));
                  setUnsavedChanges(true);
                }}
                onMigrationComplete={(type, newValue) => {
                  if (type === "doctor") {
                    setFormValues((prev: any) => ({ ...prev, doctorNumber: newValue }));
                    const doctorPK = currentDoctor?.id || (currentDoctor as any)?.id;
                    if (doctorPK) getDoctorById(doctorPK).then((doc) => { if (doc) setCurrentDoctor(doc as any); });
                  } else {
                    setFormValues((prev: any) => ({ ...prev, practiceNumber: newValue }));
                    const clinicPK = currentClinic?.id;
                    if (clinicPK) getClinicById(clinicPK).then((cli) => { if (cli) setCurrentClinic(cli as any); });
                  }
                }}
              />

                <Grid container>
                  <Grid item xs={4}>
                    <Controls.Checkbox
                      name="therapyReport"
                      label={<Typography variant="body1">Therapiebericht</Typography>}
                      value={formValues?.therapyReport}
                      onChange={handleInputChange}
                    />
                  </Grid>
                  <Grid item xs={8}>
                    <Typography variant="body1" sx={{ marginTop: "8px", align: "left" }}>
                      Hausbesuch
                    </Typography>
                    <FormControlLabel
                      label=""
                      control={
                        <>
                          <Checkbox
                            checked={formValues.isHomeVisit === true}
                            onChange={handleCheckboxChange}
                            name="visitTypeCheckboxJa"
                            value="yes"
                          />
                          <Typography variant="body1">ja</Typography>
                          <Checkbox
                            checked={formValues.isHomeVisit === false}
                            onChange={handleCheckboxChange}
                            name="visitTypeCheckboxNein"
                            value="no"
                          />
                          <Typography variant="body1">nein</Typography>
                        </>
                      }
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Controls.RadioGroup
                    label={
                      <Typography sx={{ textAlign: "left" }}>Arztunterschrift vorhanden</Typography>
                    }
                    name="signatureStatus"
                    value={formValues?.signatureStatus}
                    options={[
                      { id: "nicht kontrolliert", label: "nicht kontrolliert" },
                      { id: "vorhanden", label: "vorhanden" },
                      { id: "fehlend", label: "fehlend" },
                    ]}
                    onChange={handleInputChange}
                    sx={{
                      width: "100%",
                      paddingLeft: "1rem",
                      textAlign: "left",
                      fontSize: "0.7rem",
                    }}
                  />
                </Grid>
              {/* END */}
            </Grid>
            <Grid item xs={12} sx={{ border: "0px dotted black" }}>
              <FlatCard title="Validierung">
                <ValidationCard
                  patientData={patientValues}
                  selectedRx={
                    patientValues?.rxs?.filter((rx: any) => rx.rxNumber === formValues?.rxNumber)[0]
                  }
                  form={formType.LONG}
                />
              </FlatCard>
            </Grid>
          </Grid>
        </Grid>

        {/* Right Side */}
        <Grid item xs={12} md={6}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FlatCard title="Behandlungen">
                <Typography>Doppelbehandlungen an Hand der Heilmittelauswahl angegeben (z.B. KG2, MT2)</Typography>
                <EditTable
                  initialColumns={treatmentColumns}
                  initialRows={therapyTableData}
                  onTableDataChange={handletherapyTableDataChange}
                  parseInput={handleParseInput}
                  masterTablesData={masterTablesData}
                  selectedRx={{ ...formValues, therapyType: accountTherapyType }}
                  suppressDouble={true}
                />
              </FlatCard>
            </Grid>
            <Grid item xs={12}>
              <FlatCard title="Diagnose">
                {formValues.icdCodeEntries?.map((icdEntry: any, index: any) => (
                  <div key={`icd-${index}`}>
                    <Controls.Input
                      label={`ICD ${index + 1}`}
                      name={`icdCodeEntries-${index}`}
                      value={icdEntry.userText}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        handleInputChange(e, index, icdEntry?.id);
                      }}
                      onKeyPress={(e: React.KeyboardEvent<HTMLInputElement>) => {
                        if (e.key === "Tab" || e.key === "Enter") {
                          e.preventDefault();
                          setCurrentICD(icdEntry.userText);
                          // handleICDCodeEntrySubmit(icdEntry, index);
                        }
                      }}
                    />
                  </div>
                ))}
                <Button onClick={handleAddInput}>
                  <Add />
                  ICD Hinzufügen
                </Button>
                <Controls.TextArea
                  name="diagnosisText"
                  rows={4}
                  placeholder="Textdiagnose"
                  value={formValues?.diagnosisText}
                  onChange={handleInputChange}
                />

                <Typography color="red" align="left">
                  ggf. Therapieziele/weitere med. Befunde und hinweise
                </Typography>
                <Controls.TextArea
                  name="additionalNotes"
                  rows={4}
                  placeholder=""
                  value={formValues?.additionalNotes}
                  onChange={handleInputChange}
                />
              </FlatCard>
            </Grid>
          </Grid>
        </Grid>
        <Modal
          open={savingRx}
          aria-labelledby="loading-modal-title"
          aria-describedby="loading-modal-description"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div>
            <CircularProgress size={60} />
          </div>
        </Modal>
        {unsavedChangesWarning && (
          <WarningDialog
            open={true} // Ensure the warning dialog is open
            onClose={handleCloseUnsavedChangesWarning} // Function to close the dialog
            onContinue={handleUnsavedChangesWarning} // Function to continue despite unsaved changes
            title="Änderungen speichern?"
            content="Du hast einige Änderungen gemacht. Möchtest du diese speichern, bevor du schließt?"
            isConfirmSave
          />
        )}
      </Grid>
    );

    // if (!selectedRxId || !entryType) {
    //   return (
    //     <Box p={2}>
    //       <span>Kein Rezept ausgewählt</span>
    //     </Box>
    //   );
    // }

    if (isRxLoading) {
      return (
        <Box display="flex" justifyContent="center" alignItems="center" p={3}>
          <CircularProgress />
        </Box>
      );
    }

    if (rxError) {
      return (
        <Box p={2}>
          <span>Fehler beim Laden des Rezepts für {selectedRxId}</span>
        </Box>
      );
    }

    return (
      <Dialog open={openRx} onClose={handleCloseRxDialog} maxWidth="lg" fullWidth>
        <DialogTitle>Private Dialog</DialogTitle>
        <DialogContent>{FormContent}</DialogContent>
        <DialogActions>
          <Button variant="text" onClick={handleCloseRxDialog}>
            Abbrechen
          </Button>
          <Button
            variant="outlined"
            onClick={handleOpenDocumentViewer}
            sx={{
              backgroundColor: "#f5f5f5",
              color: "#1976d2",
              "&:hover": { backgroundColor: "#e0e0e0" },
            }}
          >
            📄 Document Viewer
          </Button>
          <Button onClick={handleSave} variant="contained">
            Speichern
          </Button>
        </DialogActions>
        <VerordnungDialog
          openAddEditDialog={isClinicModalOpen}
          handleCloseAddEditDialog={() => { setIsClinicModalOpen(false); setIsClinicModalEditMode(false); }}
          clinicId={currentClinicId}
          setCreationResponse={setCreationResponse}
          doctorId={currentDoctorId}
          currentClinic={currentClinic}
          currentDoctor={currentDoctor}
          rxType="Privat/Selbstzahler"
          initialDoctorName={autocompleteSearchTerm}
          isEditMode={isClinicModalEditMode}
          // isDoctorNumberDisabled={isDoctorNumberDisabled}
        />
        {isDocumentViewerOpen && (
          <SimpleDocumentViewer
            open={isDocumentViewerOpen}
            onClose={handleCloseDocumentViewer}
            patientId={patientValues?.id || undefined}
          />
        )}
      </Dialog>
    );
  }
);

export default Private;
